var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sort") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sort",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 0.000000)",
    fill: "#4d4d4d",
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0707075,0 L23.327624,0 C24.1071036,0.0325 24.8342022,0.4075 25.3642483,0.97125 C32.0802447,7.7025 38.7987355,14.43125 45.5109904,21.16625 C46.1320797,21.76875 46.5062299,22.635 46.4176811,23.5075 C46.3253907,24.86625 45.1418288,26.06625 43.7836635,26.16 C43.3708511,26.19375 42.9555444,26.1775 42.542732,26.18 C29.6133476,26.18 16.6839633,26.18 3.75457898,26.18 C3.18711781,26.17375 2.60469064,26.21875 2.05468982,26.05 C0.837454451,25.665 -0.0891909197,24.42625 0.00684096937,23.12875 C0.0230541454,22.3425 0.433372217,21.62625 0.988361705,21.09375 C7.68066192,14.38625 14.371715,7.67875 21.0640152,0.9725 C21.5878255,0.41625 22.3024524,0.04375 23.0707075,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.667839686,38.90125 C1.23031218,38.20375 2.11081236,37.7875 3.00877288,37.82125 C16.4794279,37.81875 29.95133,37.81875 43.421985,37.82125 C44.9173387,37.745 46.3241435,39.005 46.4189282,40.4975 C46.5062299,41.3725 46.1270911,42.23875 45.5047545,42.84125 C38.9808219,49.38625 32.4519006,55.925 25.9254737,62.4675 C25.2407788,63.20875 24.4351086,63.97625 23.3588032,64 L23.1031339,64 C22.3249014,63.96625 21.59905,63.595 21.070251,63.0325 C14.3954111,56.34625 7.72431278,49.65625 1.05072007,42.97 C0.752647069,42.6675 0.467045736,42.345 0.279970628,41.96 C-0.197694483,40.98125 -0.0530230654,39.72375 0.667839686,38.90125 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.2bfd1dad483dc7ab5bda3015bfc7f696.svg";
export { ForwardRef as ReactComponent };